exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Booking__booking{min-height:100%;display:-webkit-box;display:-ms-flexbox;display:flex}@media (max-width:500px){.Booking__booking{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}}.Booking__content{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.Booking__loaderContainer{height:100vh;margin:0 auto;padding:80px 32px;max-width:400px}", ""]);

// exports
exports.locals = {
	"booking": "Booking__booking",
	"content": "Booking__content",
	"loaderContainer": "Booking__loaderContainer"
};